import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoanApplicationNumberService {
  // KEY IN SESSION STORAGE
  private key = 'loanApplicationDetails';

	//Flag to determine whether the application is new
	private isApplicationNew: boolean = false;

  // SUBJECT TO NOTIFY KEY STATUS CHANGES
  private subject = new BehaviorSubject<boolean>(this.hasKey());
  private factualDataId = new BehaviorSubject<string | null>("");
  public $intialValue = new Subject;

  constructor() {
    // LISTEN FOR THE STORAGE EVENT TO DETECT CHANGES FROM OTHER TABS/WINDOWS
    window.addEventListener('storage', (event) => {
      if (event.key === this.key) {
        this.subject.next(this.hasKey());
      }
    });
  }

  // CHECK IF A KEY IS PRESENT IN SESSION STORAGE
  private hasKey(): boolean {
    return localStorage.getItem(this.key) !== null;
  }

  setApplicationStatus(isNew: boolean) {
	this.isApplicationNew = isNew;
  }

  getApplicationStatus() {
	return this.isApplicationNew;
  }

  // SET THE KEY IN SESSION STORAGE
  setKey(value: {loanapplicationid: string, loanapplicationnumber: string }): void {
    localStorage.setItem(this.key, JSON.stringify(value));
    this.subject.next(true);
  }

  // SET THE KEY IN SESSION STORAGE
  getKey(): any {
    const loanAppDetails = localStorage.getItem(this.key);
    return loanAppDetails ? JSON.parse(loanAppDetails) : null;
  }
  // REMOVE THE KEY FROM SESSION STORAGE

  removeKey(): void {
    localStorage.removeItem(this.key);
    this.subject.next(false);
  }

  // OBSERVABLE TO WATCH FOR KEY CHANGES
  getStatus(): Observable<boolean> {
    return this.subject.asObservable();
  }

  // SET THE FACTUAL DATA ID KEY IN SESSION STORAGE
  setFactualKey(value: string | null): void {
    if(value)
    {
      localStorage.setItem('factualdataid', value);
    }
    this.factualDataId.next(value);
  }

  // GET THE FACTUAL DATA ID KEY IN SESSION STORAGE
  getFactualDataIdKey(): string | null {
    const value = localStorage.getItem('factualdataid');
    return value || null;
  }
  // REMOVE FACTUAL DATA ID KEY FROM SESSION STORAGE

  removeFactualDataIdKey(): void {
    localStorage.removeItem('factualdataid');
    this.factualDataId.next(null);
  }

  // OBSERVABLE TO WATCH FOR FACTUAL DATA ID KEY CHANGES
  getFactualDataIdStatus(): Observable<string | null> {
    return this.factualDataId.asObservable();
  }
}
